import { useState, useMemo, useEffect } from 'react';
import { useAtom, atom } from 'jotai';

export enum THEMES {
  // light
  DEFAULT = 'default',
  DARK = 'dark',
  SYSTEM = 'system',
}

const defaultTheme = THEMES.DEFAULT;

export const themeState = atom(defaultTheme);

// https://medium.com/hypersphere-codes/detecting-system-theme-in-javascript-css-react-f6b961916d48
const useThemeDetector = () => {
  const getCurrentTheme = () => window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [isDark, setIsDark] = useState(getCurrentTheme());
  const mqListener = (e: MediaQueryListEvent) => {
    setIsDark(e.matches);
  };

  useEffect(() => {
    const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');

    darkThemeMq.addEventListener('change', mqListener);
    return () => darkThemeMq.removeEventListener('change', mqListener);
  }, []);

  return isDark;
};

export const useTheme = () => {
  const [theme, setTheme] = useAtom(themeState);
  const isSystemDark = useThemeDetector();

  const isDark = useMemo(() => {
    return theme === THEMES.SYSTEM ? isSystemDark : theme === THEMES.DARK;
  }, [theme, isSystemDark]);

  return {
    isDark,
    theme,
    setTheme,
  };
};
